// extracted by mini-css-extract-plugin
export default {"span":"FooterGeneral_span__peIXK","footer":"FooterGeneral_footer__WIziW"};